import { removeMentionFromHtml } from './entity-utils';
import {
  buildHiddenMentionsHtml,
  extractMentionedEntityIds,
  type EntityMentionOption,
} from './entity-mentions';
import { uniqueIds } from './resource-bulk-assign';

const TIMELINE_LINKED_DOCUMENTS_SELECTOR = '[data-timeline-linked-documents="true"]';

export function stripTimelineLinkedDocumentsBlock(html: string): string {
  if (!html) {
    return html;
  }
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll(TIMELINE_LINKED_DOCUMENTS_SELECTOR).forEach((el) => el.remove());
  return doc.body.innerHTML;
}

export function applyDocumentAssignment(params: {
  html: string | null;
  currentDocumentIds: string[];
  addedDocumentIds: string[];
  removedDocumentIds: string[];
  documentOptionsById: Map<string, EntityMentionOption>;
}): string {
  const removedSet = new Set(params.removedDocumentIds);
  let html = stripTimelineLinkedDocumentsBlock(params.html ?? '');
  for (const id of removedSet) {
    html = removeMentionFromHtml(html, { type: 'document', id });
  }

  const nextIds = uniqueIds([
    ...params.currentDocumentIds.filter((id) => !removedSet.has(id)),
    ...params.addedDocumentIds,
  ]);
  const contentIds = new Set(extractMentionedEntityIds(html, 'document'));
  const hiddenIds = nextIds.filter((id) => !contentIds.has(id));
  const mentions = buildHiddenMentionsHtml('document', hiddenIds, params.documentOptionsById);
  if (!mentions) {
    return html;
  }
  const base = html.trim();
  return `${base}<p style="display:none" data-timeline-linked-documents="true">${mentions}</p>`;
}
